import Vue from 'vue'

Vue.mixin({
    methods: {
        showSuccess(message) {
            this.$buefy.toast.open({
                message: message,
                duration: 6000,
                type: "is-success"
            })
        },
        showError(message) {
            this.$buefy.toast.open({
                message: message,
                duration: 8000,
                type: "is-danger"
            })
        }
    },
})